module.exports = __webpack_public_path__ + "static/media/house.8dcf1316.svg";